import type { StatusTone } from "@/pages/home/content";

const toneMap: Record<StatusTone, string> = {
  待证实: "bg-secondary-200/80 text-secondary-900 border-secondary-300/60",
  进展中: "bg-accent-100 text-accent-900 border-accent-300/70",
  已回应: "bg-secondary-100 text-secondary-800 border-secondary-300/50",
  实锤: "bg-primary-500 text-background-50 border-primary-500",
};

export default function StatusBadge({ tone }: { tone: StatusTone }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs whitespace-nowrap ${toneMap[tone]}`}
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-current" />
      {tone}
    </span>
  );
}